export function createResourceAssetFromProgramme(programme, file) {
  if (!programme || !file) return null

  return {
    id: `programme-${programme.id}-${file.id || file.fileName}`,
    sourceType: 'programme',
    relatedEntityId: programme.id || '',
    name: file.fileName || programme.name || '方案资料',
    type: '方案附件',
    industry: programme.categoryLabel || '',
    usage: programme.useCases || programme.remark || '',
    content: programme.remark || '',
    sceneTags: (programme.categoryLabel || '')
      .split(/[、,，/]/)
      .map((item) => item.trim())
      .filter(Boolean),
    files: [
      {
        name: file.fileName || '附件',
        url: file.filePath || ''
      }
    ],
    updated: programme.programmeDate || programme.creationDate || '',
    raw: {
      programme,
      file
    }
  }
}

function extractFileNameFromUrl(url) {
  if (!url) return ''
  const clean = String(url).split('#')[0].split('?')[0]
  const parts = clean.split('/')
  const name = parts[parts.length - 1] || ''
  return name.trim()
}

export function createResourceAssetFromCertification(certification, field) {
  if (!certification || !field || !certification[field.urlKey]) return null

  const uploadedUrl = certification[field.urlKey]
  const fileNameFromUrl = extractFileNameFromUrl(uploadedUrl)
  const fileName = fileNameFromUrl || field.name

  return {
    id: `certification-${field.type}-${certification.id || certification.name}`,
    sourceType: field.type,
    relatedEntityId: certification.id || '',
    name: field.name,
    type: field.label,
    industry: certification.expertiseLabel || '',
    usage: certification.profile || '',
    content: certification.profile || '',
    // 认证资料当前没有单独的“适用场景标签”后端字段，避免与适用行业重复展示
    sceneTags: ['通用'],
    files: [
      {
        // 显示真实上传后的文件名（用户更直观）
        name: fileName,
        url: uploadedUrl
      }
    ],
    updated: certification.modificationDate || certification.creationDate || '',
    raw: certification
  }
}

export function createResourceAssetFromCase(caseInfo) {
  if (!caseInfo || !caseInfo.materialUrl) return null

  const fileNameFromUrl = extractFileNameFromUrl(caseInfo.materialUrl)
  const industryValue =
    caseInfo.industryLabel ||
    caseInfo.categoryLabel ||
    caseInfo.industry ||
    ''
  const sceneValue = caseInfo.programmeTypeLabel || caseInfo.programmeType || '成功案例'

  return {
    id: `case-${caseInfo.id || caseInfo.projectName}`,
    sourceType: 'case',
    relatedEntityId: caseInfo.entityId || '',
    name: caseInfo.projectName || '成功案例材料',
    type: '案例证明',
    industry: industryValue,
    usage: caseInfo.deliveryScope || '',
    content: caseInfo.customerName || '',
    sceneTags: [sceneValue],
    files: [
      {
        name: fileNameFromUrl || `${caseInfo.projectName || '案例'}材料`,
        url: caseInfo.materialUrl
      }
    ],
    updated: '',
    raw: caseInfo
  }
}
